module.exports = __webpack_public_path__ + "static/scoring-1-a790e3eaff6b92216f72f6a82d16c5d3.png";